<template>
  <div class="p-4 space-y-4">
    <!-- Name -->
    <div>
      <label class="block text-sm font-medium text-gray-700">Name</label>
      <InputText v-model="name" class="w-full" />
    </div>

    <!-- Add Values Individually -->
    <div>
      <label class="block text-sm font-medium text-gray-700"> New Value </label>
      <div class="flex gap-2">
        <InputText
          v-model="newValue"
          placeholder="Enter value"
          class="flex-1"
          @keyup.enter="addValue"
        />
        <Button label="Add" icon="pi pi-plus" :disabled="!newValue" @click="addValue" />
      </div>
    </div>

    <!-- Current Values List -->
    <div v-if="values.length">
      <label class="block text-sm font-medium text-gray-700"> Values </label>
      <ul class="list-disc list-inside space-y-1">
        <li v-for="(val, idx) in values" :key="idx" class="flex justify-between">
          <span>{{ val }}</span>
          <Button
            icon="pi pi-trash"
            class="p-button-text p-button-danger"
            @click="removeValue(idx)"
          />
        </li>
      </ul>
    </div>

    <!-- Error Message (PrimeVue 4 Message has no `text` prop — use default slot) -->
    <Message v-if="error" severity="error">{{ error }}</Message>

    <!-- Actions -->
    <div class="flex justify-end space-x-2">
      <Button label="Cancel" class="p-button-secondary" @click="onHide" />
      <Button
        label="Create"
        icon="pi pi-check"
        @click="submit"
        :disabled="!name || !values.length || loading"
      />
      <ProgressSpinner v-if="loading" />
    </div>
  </div>
</template>

<script>
import InputText from 'primevue/inputtext';
import Button from 'primevue/button';
import Message from 'primevue/message';
import ProgressSpinner from 'primevue/progressspinner';
import { mapState, mapActions } from 'vuex';

export default {
  name: 'NewEnumDialog',
  components: {
    InputText,
    Button,
    Message,
    ProgressSpinner,
  },
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      name: '',
      newValue: '',
      values: [],
    };
  },
  computed: {
    ...mapState('enums', {
      loading: (state) => state.loading,
      error: (state) => state.error,
    }),
  },
  watch: {
    visible(val) {
      if (val) {
        this.clearError();
      }
    },
  },
  methods: {
    ...mapActions('enums', ['createEnumType', 'clearError']),
    onHide() {
      this.clearError();
      this.$emit('update:visible', false);
      this.resetForm();
    },
    resetForm() {
      this.name = '';
      this.newValue = '';
      this.values = [];
    },
    addValue() {
      if (this.newValue.trim()) {
        this.values.push(this.newValue.trim());
        this.newValue = '';
      }
    },
    removeValue(idx) {
      this.values.splice(idx, 1);
    },
    async submit() {
      try {
        await this.createEnumType({ name: this.name, values: this.values });
        this.onHide();
      } catch (e) {
        // error already in store.error
      }
    },
  },
};
</script>

<style scoped></style>
